import React from 'react';
import { CheckCircle2Icon, CircleDashedIcon, FlaskConicalIcon, PhoneIcon } from 'lucide-react';
import { useFunnel } from '../../contexts/FunnelContext';
import { phones } from '../../data/siteConfig';
import type { StringKey } from '../../data/i18n';
export function StepStatus() {
  const {
    t,
    submitted,
    reset
  } = useFunnel();
  if (!submitted) return null;
  const preview = submitted.mode === 'preview';
  const rows: {
    label: StringKey;
    value: StringKey;
    done: boolean;
  }[] = [{
    label: 'rowEstimate',
    value: 'stAccepted',
    done: submitted.estimateStatus === 'accepted'
  }, {
    label: 'rowDocuments',
    value: 'stDocsNot',
    done: false
  }, {
    label: 'rowDeposit',
    value: submitted.summary.paymentMethod === 'zelle' ? 'stDepZelle' : 'stDepNot',
    done: false
  }, {
    label: 'rowDispatch',
    value: 'stDispatch',
    done: false
  }];
  return <div data-id="element-974" data-mp="3m3tjzovarnmn">
      <h1 className="font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-975" data-mp="3m439zcgcdusc">{t('statusTitle')}</h1>
      {preview ? <p role="status" className="mt-4 flex items-start gap-2 rounded-xl border border-dashed border-ink-400 bg-ink-100 p-4 text-[15px] font-medium text-ink" data-id="element-976" data-mp="32ajh2km3szlc">
          <FlaskConicalIcon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" data-id="element-977" data-mp="2y9zjjfxmbtyo" />
          {t('previewBanner')}
        </p> : <p role="status" className="mt-4 text-lg text-ink-700" data-id="element-978" data-mp="2obac6h3clrwo">
          {t('liveReceived')}
        </p>}

      <p className="mt-6 text-sm text-ink-500" data-id="element-979" data-mp="2jc77ixra5np8">{t('refLabel')}</p>
      <p className="font-mono text-xl font-bold text-ink" data-id="element-980" data-mp="2jds0iixy4ykz">{submitted.id}</p>

      <ul className="mt-6 divide-y divide-ink-200 rounded-2xl bg-white ring-1 ring-ink-200" data-id="element-981" data-mp="2ejxn1x8xpfuc">
        {rows.map(r => <li key={r.label} className="flex items-center gap-3 p-4" data-id="element-982" data-mp="25kixr14i7bbf">
            {r.done ? <CheckCircle2Icon className="h-5 w-5 text-lime-dark" aria-hidden="true" data-id="element-983" data-mp="25ifxzpdju3ti" /> : <CircleDashedIcon className="h-5 w-5 text-ink-400" aria-hidden="true" data-id="element-984" data-mp="20k4qvmen27ez" />}
            <span className="flex-1 font-semibold text-ink" data-id="element-985" data-mp="1vneaexyx99t1">{t(r.label)}</span>
            <span className="text-right text-sm text-ink-600" data-id="element-986" data-mp="1ly7leqyc5jwr">{t(r.value)}</span>
          </li>)}
      </ul>

      <section className="mt-8" data-id="element-987" data-mp="1qyvav86x1sov">
        <h2 className="font-display text-lg font-extrabold text-ink" data-id="element-988" data-mp="1qz54d5r66hzb">{t('nextTitle')}</h2>
        <ol className="mt-3 space-y-2 text-[15px] text-ink-700" data-id="element-989" data-mp="1czncghikuolq">
          {(['next1', 'next2', 'next3'] as StringKey[]).map((k, i) => <li key={k} className="flex gap-3" data-id="element-990" data-mp="24p8mplmxhrjh" data-mpi={i}>
              <span className="font-display font-black text-magenta" data-id="element-991" data-mp="24qjpbi4n0t90">{i + 1}</span>
              {t(k)}
            </li>)}
        </ol>
      </section>

      <div className="mt-8 flex flex-wrap gap-3" data-id="element-992" data-mp="1vxgd1d5qamfy">
        <a href={phones.ai.href} className="inline-flex h-12 items-center gap-2 rounded-xl bg-ink px-5 font-bold text-white hover:bg-ink-700" data-id="element-993" data-mp="1vwoh2187ymp5">
          <PhoneIcon className="h-4 w-4 text-lime" aria-hidden="true" data-id="element-994" data-mp="2nocp4bjysn26" />
          {t('callKyle')}: {phones.ai.display}
        </a>
        <a href={phones.human.href} className="inline-flex h-12 items-center rounded-xl border-2 border-ink-200 px-5 font-semibold text-ink hover:border-ink" data-id="element-995" data-mp="2sfuoiv6cafl1">
          {t('humanHelp')}: {phones.human.display}
        </a>
        <button type="button" onClick={reset} className="inline-flex h-12 items-center rounded-xl px-3 font-semibold text-ink underline underline-offset-4" data-id="element-996" data-mp="c0hahntztsjk">
          {t('newMove')}
        </button>
      </div>
      <p className="mt-2 text-xs text-ink-500" data-id="element-997" data-mp="lsnczrhvfsd0">{t('aiLabel')}</p>
    </div>;
}